import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { detailsSidebarResourceIdSelector, DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { SymbolLpAction, symbolLpSelector } from '@cbridge-packages/symbol-lp';

type IState =
  IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>
  & IGetSelectorStateType<typeof symbolLpSelector>;

export const closeSymbolLpBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolLpAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { coreSymbolId, lpId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);
    if (openedDetailsId && symbolLpSelector(state, { lpId, name: String(openedDetailsId) })?.coreSymbolId === coreSymbolId) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
